import { apicall } from "./api";
import axios from "axios";

// store our JWT in LS and set axios headers if we do have a token

const setAuthToken = (token) => {
	if (token) {
		axios.defaults.headers.common["accessToken"] = token;
		localStorage.setItem("accessToken", token);
	} else {
		delete axios.defaults.headers.common["accessToken"];
		localStorage.removeItem("accessToken");
	}
};

export default setAuthToken;
